import { useQuery } from '@tanstack/react-query';
import studioApiClient from '../api/studio';

export const STUDIO_GUIDES_QUERY_KEY = 'studio-guides';

const THIRTY_MINUTES = 30 * 60 * 1000;

const useStudioGuides = () => {
  return useQuery({
    queryKey: [STUDIO_GUIDES_QUERY_KEY],
    queryFn: () => studioApiClient.getGuides(),
    staleTime: THIRTY_MINUTES,
  });
};

export default useStudioGuides;
